import React, { Children, useEffect, useState } from "react"
import PropTypes from "prop-types"
// Component
import Tooltip from "@mui/material/Tooltip"
// Style
import { RowGanttContainer, Marker, ColStep, RowStep } from "../index.style"

const RowGantt = ({
  responsableInProgressStep,
  responsableAfterStep,
  inProgressNameStep,
  advancementStep,
  afterNameStep,
  nbColumns,
  timming,
  isDelay,
  name,
  step,
}) => {
  const widthStep = 50 / nbColumns
  const widthStepActive = widthStep * step
  const widthRow = widthStepActive + 50
  const colorMarker = isDelay ? "#F31606" : "#7b3063"

  return (
    <RowGanttContainer width={widthRow} isDelay={isDelay}>
      <div className="row">
        <div className="labelStepContainer">Phase {step}</div>
      </div>

      <div className="infosGlobal">
        <div className="infosLeft">
          <div className="nameRow">
            <div className="name">{name}</div>
            {responsableInProgressStep !== "" && (
              <div className="etiquetteName">{responsableInProgressStep}</div>
            )}
          </div>
          <div className="step">
            <div className="stepName">
              <Marker colorMarker={colorMarker} />
              Etape en cours: {inProgressNameStep}
            </div>
          </div>
          <div className="timming">
            <div>
              Timing: <span className={isDelay ? "delay" : ""}>{timming}</span>
            </div>
            <Tooltip title="Fonctionnalité en cours de développement.">
              <div className="button" style={{ opacity: "0.5", cursor: "no-drop" }}>
                Envoyer une relance
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="infosRight">
          <div className="nameUser">
            {responsableAfterStep !== "" && (
              <div className="etiquetteName">{responsableAfterStep}</div>
            )}
          </div>
          <div className="step">
            <div className="stepName">
              <Marker />
              Etape à venir: {afterNameStep}
            </div>
          </div>
        </div>
      </div>

      {Children.toArray(
        advancementStep?.map((phase, indexCol) => {
          const postionStep = 50 + widthStep * indexCol
          const isCompleted = phase?.length === 1
          const statusClass = isCompleted ? "isCompleted" : ""
          return (
            <ColStep
              widthStep={widthStep}
              postionStep={postionStep}
              isCompleted={isCompleted}
              colorMarker={colorMarker}
              nbColumns={phase?.length}
            >
              {Children.toArray(
                phase?.map((step, indexRow) => {
                  return (
                    <RowStep
                      className={`rowStep ${statusClass} ${step}`}
                      rowStep={indexRow}
                    ></RowStep>
                  )
                })
              )}
            </ColStep>
          )
        })
      )}
    </RowGanttContainer>
  )
}

RowGantt.propTypes = {
  responsableInProgressStep: PropTypes.string,
  responsableAfterStep: PropTypes.string,
  nbColumns: PropTypes.number,
  inProgressNameStep: PropTypes.string,
  advancementStep: PropTypes.array,
  afterNameStep: PropTypes.string,
  timming: PropTypes.string,
  isDelay: PropTypes.bool,
  name: PropTypes.string,
  step: PropTypes.number,
}

RowGantt.defaultProps = {
  responsableInProgressStep: "",
  responsableAfterStep: "",
  nbColumns: 0,
  inProgressNameStep: "",
  advancementStep: [],
  afterNameStep: "",
  timming: "",
  isDelay: false,
  name: "",
  step: 0,
}

export default RowGantt
